import React, { useState, useEffect, useContext, useRef, useMemo, useCallback } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom'
import { message, Divider, Table, Pagination, Row, Col, InputNumber, Radio, Button, Spin, Tabs, Tag, Space } from 'antd';
import API from '@api/api.js';
import styles from './index.module.scss'

// 待支付
const DeliveryBillTable = (props) => {
    const {
        type,
        actived,
        force,
        onPay,
        onDownload,
        onView,
        onConfirm,
        onTotal,
    } = props
    // 待支付
    const [pageSize] = useState(10)
    const [loading3, setLoading3] = useState(false)
    const [pageIndex3, setpageIndex3] = useState(1)
    const [dataSource3, setDataSource3] = useState([])
    const [total3, setTotal3] = useState(0)
    const [sortInfo, setSortInfo] = useState({})
    const columns3 = useMemo(() => [{
        title: '结算编号',
        key: 'billId',
        dataIndex: 'billId',
    }, {
        title: '总价',
        key: 'amount',
        dataIndex: 'amount',
        minWidth: 140,
        render: (text) => (
            <p>￥{text}</p>
        )
    }, {
        title: '发起时间',
        dataIndex: 'createdTime',
        key: 'createdTime',
        minWidth: 180,
        sorter: true,
        sortOrder: sortInfo.columnKey == 'createdTime' ? sortInfo.order : null,
    }, {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        minWidth: 100,
        render: (text) => (
            <p>{text == 0 ? '待确认' : text == 1 ? '已支付' : '待支付'}</p>
        )
    }, {
        title: '结算清单',
        key: "download",
        render: (_, record) => (
            <Space>
                <Button type="link" onClick={() => props.onView(record)}>查看</Button>
                <Button type="link" onClick={() => props.onDownload(record)}>下载</Button>
            </Space>
        )
    }, {
        title: '操作',
        key: 'action',
        render: (_, record) => {
            // 0待确认1已结算3待支付
            if (record.status == 0) {
                return <Button style={{width: 100}} type="primary" size="small" onClick={() => onConfirm(record)}>确认</Button>
            } else if (record.status == 1) {
                return null
            } else if (record.status == 3) {
                return <Button style={{width: 100}} type="primary" size="small" onClick={() => onPay(record)}>支付</Button>
            }
        }
    }], [
        onDownload,
        onPay,
        onView,
        onConfirm,
        sortInfo
    ])
    useEffect(() => {
        // if (!actived) return
        setLoading3(true)
        const params = new URLSearchParams()
        params.append('pageIndex', pageIndex3)
        params.append('pageSize', pageSize)
        if (sortInfo && sortInfo.order) {
            params.append('order', sortInfo.order == 'ascend' ? 'asc' : 'desc')
        }
        // 0待确认1已结算3待支付
        if (type == 'waitPay') {
            params.append('status', 3)
        } else if (type == 'confirm') {
            params.append('status', 0)
        }
        API.getDeliveryBillList(params).then((res) => {
            setLoading3(false)
            if (res.code === 0) {
                setDataSource3(res.data.items)
                setTotal3(res.data.total)
                onTotal?.(res.data.total)
            } else {
                message.warning(res.message)
            }
        }).catch(() => {
            setLoading3(false)
        })
    }, [
        type,
        actived,
        pageIndex3,
        pageSize,
        sortInfo,
        force
    ])

    return (
        dataSource3.length == 0 ? <div className={styles.null_content}></div> :
        <div className={styles.table_content}>
            <div className={styles.TableBox}>
                {/* <Table
                    className="customTable"
                    rowKey="id"
                    loading={loading3}
                    columns={columns3}
                    dataSource={dataSource3}
                    scroll={{
                        x: 'max-content',
                        y: `max-content`,
                    }}
                    pagination={false}
                    onChange={(a, b, sorter) => {
                        setSortInfo(sorter)
                    }}
                /> */}
                <Table
                    className="customTable"
                    rowKey="id"
                    loading={loading3}
                    columns={columns3}
                    dataSource={dataSource3}
                    scroll={{
                        x: 'max-content',
                        y: `max-content`,
                    }}
                    pagination={{
                        current: pageIndex3,
                        pageSize: pageSize,
                        total: total3,
                        showSizeChanger: false,
                        showQuickJumper: true,
                        hideOnSinglePage: true,
                        placement: ['bottomCenter']
                    }}
                    onChange={({current, pageSize}, _, sorter) => {
                        setpageIndex3(current)
                        setSortInfo(sorter)
                    }}
                />
            </div>
            {/* <div className={styles.FooterBox}>
                <Pagination
                    current={pageIndex3}
                    pageSize={pageSize}
                    total={total3}
                    showSizeChanger={false}
                    showQuickJumper={true}
                    hideOnSinglePage={false}
                    align="center"
                    onChange={(page) => {
                        setpageIndex3(page)
                    }}
                />
                {type == "waitPay" ?
                <Button className={styles.BatchPayBtn} type="primary" onClick={() => onBatchPay()}>支付全部</Button> :
                null}
            </div> */}
        </div>
    )
}

export default DeliveryBillTable
